import React from 'react';
import { useTranslates } from 'providers/translates';
import styles from './footer.module.scss';
import { Link } from 'react-router-dom';
import { useAuth } from 'providers/auth-provider';
import { TProfile } from 'api/http-client/profileTypes';
import { useAppSelector } from 'hooks';
import { isVac } from 'utilities/is-vac';
import { Language } from 'providers/translates/enums';
import { vacFooterLabel } from 'utilities/vac-copy';

const Footer: React.FC = () => {
  const { translates: t, selectedLang } = useTranslates();
  const isFrench = selectedLang === Language.FRENCH;
  const user = useAuth().user as unknown as TProfile;
  const editableQuilt = useAppSelector((state) => state.quilt.editableQuilt);

  const nameRow = `Name associated with your account: ${user?.firstName ?? ''} ${user?.lastName ?? ''}\n`;
  const emailRow = `Email address associated with your account: ${user?.email ?? ''}\n`;
  const quiltNameRow = `Name of the quilt you need help with: ${editableQuilt?.firstName ?? ''} ${editableQuilt?.lastName ?? ''}\n`;
  const issueOrConcernRow = `Issue or concern:`;

  const nameRowVac = `Name associated with your account: ${user?.firstName ?? ''} ${user?.lastName ?? ''}\n`;
  const emailRowVac = `Email address associated with your account: ${user?.email ?? ''}\n`;
  const quiltNameRowVac = `Name of the quilt you need help with: ${editableQuilt?.firstName ?? ''} ${editableQuilt?.lastName ?? ''}\n`;
  const issueOrConcernRowVac = `Issue or concern:`;

  const nameRowFr = `Nom associé à votre compte: ${user?.firstName ?? ''} ${user?.lastName ?? ''}\n`;
  const emailRowFr = `Adresse courriel associée à votre compte: ${user?.email ?? ''}\n`;
  const quiltNameRowFr = `Nom du carreau de courtepointe pour lequel vous avez besoin d’aide: ${editableQuilt?.firstName ?? ''} ${editableQuilt?.lastName ?? ''}\n`;
  const issueOrConcernRowFr = `De quoi s’agit-il?`;

  let contactUsEmail: { subject: string; body: string; };

  if (isVac()) {
    contactUsEmail = isFrench ? {
      subject: encodeURIComponent('J’ai une question concernant SaluonsLeurService.ca'),
      body: encodeURIComponent(
        `\n\n\nN.B. – Si vous êtes un utilisateur actuel du site SaluonsLeurService.ca et que vous avez besoin d’assistance, veuillez nous fournir les renseignements suivants pour nous aider à vous faciliter la tâche.\n\n${nameRowFr}${emailRowFr}${quiltNameRowFr}${issueOrConcernRowFr}`
      ),
    } : {
      subject: encodeURIComponent('I have a question about SalutingService.ca'),
      body: encodeURIComponent(
        `\n\n\nNote: If you are a current SalutingService.ca user and are looking for assistance, please provide us with the following information so we can help you as easily as possible:\n\n${nameRowVac}${emailRowVac}${quiltNameRowVac}${issueOrConcernRowVac}`
      ),
    }
  } else {
    contactUsEmail = {
      subject: encodeURIComponent('I have a question about the Canadian Healing Quilt'),
      body: encodeURIComponent(
        `\n\n\nNote: If you are a current Canadian Healing Quilt user and are looking for assistance please provide us with the following information so we can help you as easily as possible:\n\n${nameRow}${emailRow}${quiltNameRow}${issueOrConcernRow}`
      )
    }
  }
  
  const anchorContactUsEmail = () => {
    return (
      <a href={`mailto:${isFrench ? 'info@portailpallatif.ca' : 'info@virtualhospice.ca'}?subject=${contactUsEmail.subject}&body=${contactUsEmail.body}`}>
        {vacFooterLabel(selectedLang, t?.footer?.contactUs, 'contactUs', 'Contact us')}
      </a>
    )
  }

  return (
    <footer className={styles.footer}>
      <div className="center">
        <div className={styles.footer_block}>
        {!isVac() ? (
            <a
            href="https://www.virtualhospice.ca/en_US/Main+Site+Navigation/Home.aspx"
            target="__blank"
            className="logo"
          >
            <img src="/img/general/logo-white-footer.png" alt="VirtualHospice" />
          </a>
          ) : (
            isFrench ? <a
            href="https://www.virtualhospice.ca/en_US/Main+Site+Navigation/Home.aspx"
            target="__blank"
            className="logo"
          >
            <img src="/img/general/CVH-Logo-New-French-Reverse.png" alt="VirtualHospice" />
          </a> : <a
            href="https://www.virtualhospice.ca/en_US/Main+Site+Navigation/Home.aspx"
            target="__blank"
            className="logo"
          >
            <img src="/img/general/logo-white-footer.png" alt="VirtualHospice" />
          </a>
          )}
          <div className={styles.footer_info}>
            <ul className={`${styles.footer_list} ${styles.isDesktop}`}>
              <li>
                {anchorContactUsEmail()}
              </li>
              <li className={styles.footer_verticalLine}></li>
              <li>
                <Link to="/about/?visible=notice">
                  {vacFooterLabel(selectedLang, t?.footer?.privacyNotice, 'privacyNotice', 'Privacy Notice')}
                </Link>
              </li>
              <li className={styles.footer_verticalLine}></li>
              <li>
              <a href={isFrench ? 'https://www.virtualhospice.ca/fr_CA/Main+Site+Navigation/Right+Footer+Navigation/Privacy+Policy.aspx' : 'https://www.virtualhospice.ca/en_US/Main+Site+Navigation/Right+Footer+Navigation/Privacy+Policy.aspx'}>
                {vacFooterLabel(selectedLang, t?.footer?.privacyPolicy, 'privacyPolicy', 'Privacy Policy')}
              </a>
              </li>
            </ul>
            <ul className={`${styles.footer_list} ${styles.isMobile}`}>
              <li>
                {anchorContactUsEmail()}
              </li>
            </ul>
            <ul className={`${styles.footer_list} ${styles.isMobile}`}>
              <li>
                <Link to="/about/?visible=notice">
                  {vacFooterLabel(selectedLang, t?.footer?.privacyNotice, 'privacyNotice', 'Privacy Notice')}
                </Link>
              </li>
              <li className={styles.footer_verticalLine}></li>
              <li>
              <a href={isFrench ? 'https://www.virtualhospice.ca/fr_CA/Main+Site+Navigation/Right+Footer+Navigation/Privacy+Policy.aspx' : 'https://www.virtualhospice.ca/en_US/Main+Site+Navigation/Right+Footer+Navigation/Privacy+Policy.aspx'}>
                {vacFooterLabel(selectedLang, t?.footer?.privacyPolicy, 'privacyPolicy', 'Privacy Policy')}
              </a>
              </li>
            </ul>

            <span className={styles.footer_copyright}>
              {vacFooterLabel(
                selectedLang,
                t?.footer?.copyright,
                'copyright',
                'Copyright 2016-2024 Canadian Virtual Hospice. All Rights Reserved.'
              )}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
